import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class P2PPlayerSettingsRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery(fields) {
    return gql`
            query GetP2PPlayerSettings($uid: String!) {
                ${this.getP2PUserProfileQuery(fields)}
                ${this.getP2PLimitsV2Query(fields)}
                ${this.getP2PGlobalSettingsQuery(fields)}
            }
        `;
  }
  buildFilter(filter) {
    return { uid: this.toGQLStringFilter(filter, "uid") };
  }
  hasPagination() {
    return false;
  }
  getP2PUserProfileQuery(fields) {
    const userProfilePrefix = "user_profile.";
    const userProfileFields = fields.filter((f) => f.includes(userProfilePrefix)).map((f) => f.replace(userProfilePrefix, ""));
    return `getUserProfile(uid: $uid) {
                    uid
                    ${this.buildQueryFields(userProfileFields)}
                }`;
  }
  getP2PGlobalSettingsQuery(fields) {
    const globalSettingsPrefix = "global_settings.";
    const globalSettingsFields = fields.filter((f) => f.includes(globalSettingsPrefix)).map((f) => f.replace(globalSettingsPrefix, ""));
    return globalSettingsFields?.length > 0 ? `
                getP2PPlayerGlobalSettings(uid: $uid) {
                    ${this.buildQueryFields(globalSettingsFields)}
                }` : "";
  }
  getP2PLimitsV2Query(fields) {
    const limitsPrefix = "personal_limits_v2.";
    const limitFields = fields.filter((f) => f.includes(limitsPrefix)).map((f) => f.replace(limitsPrefix, ""));
    return limitFields?.length > 0 ? `
                getP2PPlayerPersonalLimitsV2(uid: $uid) {
                    ${this.buildQueryFields(limitFields)}
                }` : "";
  }
}
export {
  P2PPlayerSettingsRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
